import { useState } from 'react';

const damageTypes = ['Chipped', 'Crack', 'Completely Broken'];

const Step3 = ({
    formValues,
    handleChange,
    handleNextStep,
    handlePrevStep,
    errors
}) => {
    const [damageType, setDamageType] = useState('');
    const [description, setDescription] = useState('');

    const handleDamageTypeSelect = (type) => {
        setDamageType(type);
        updateDamageDescription(type, description);
    };

    const handleDescriptionChange = (e) => {
        const value = e.target.value;
        setDescription(value);
        updateDamageDescription(damageType, value);
    };

    const updateDamageDescription = (type, desc) => {
        const combined = desc ? `${type} - ${desc}` : type;
        handleChange({ target: { name: 'damageDescription', value: combined } });
    };

    return (
        <div className="flex flex-col gap-4 w-full h-full">
            <div className="flex flex-col gap-4">
                <label className="text-sm font-medium">Select Damage Type:</label>
                <div className="flex gap-3">
                    {damageTypes.map((type) => (
                        <button
                            key={type}
                            type="button"
                            onClick={() => handleDamageTypeSelect(type)}
                            className={`px-4 py-2 rounded-xl border-2 transition-all ${
                                damageType === type
                                    ? 'bg-primary text-white border-primary shadow-md'
                                    : 'bg-white text-gray-700 border-gray-300 hover:border-primary hover:text-primary'
                            }`}
                            
                        >
                            {type}
                        </button>
                    ))}
                </div>

                <label className="text-sm font-medium mt-4">Optional Description:</label>
                <textarea
                    value={description}
                    onChange={handleDescriptionChange}
                    placeholder="Describe the damage (optional)"
                    className={`p-2 rounded-lg bg-white border-2 ${
                        errors.damageDescription ? 'border-red-500' : 'border-primary'
                    } h-40 resize-none`}
                />
                {errors.damageDescription && (
                    <div className="text-red-500 text-sm">{errors.damageDescription}</div>
                )}
            </div>
        </div>
    );
};

export default Step3;
